import React from 'react'
import axios from 'axios'
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
	CardTitle,
	Button,
	Input
} from 'reactstrap'

import IngredientsActions from '~/actions/ingredients.js'

import apiUtils from '~/helper/api.js'


export default class RecipeIngredientsModalAdd extends React.Component {
	static getDefaultState() {
		return {
			btnSubmitDisabled: true,
			ingredient: ''
		}
	}

	constructor(props) {
		super(props)

		this.state = RecipeIngredientsModalAdd.getDefaultState()
	}

	setSubmitButtonStatus = () => {
		this.setState({
			btnSubmitDisabled: (
				this.state.ingredient === ''
			)
		})
	}

	handleChange = (event) => {
		this.setState(
			{ [event.target.name]: event.target.value },
			this.setSubmitButtonStatus
		)
	}

	submit = () => {
		this.setState({ btnSubmitDisabled: true })

		axios.post(
			`${apiUtils.getApiURL()}/ingredients`,
			{
				ingredient: this.state.ingredient,
				isActive: 1
			}
		)
			.then(
				() => {
					// clear the form
					this.setState(RecipeIngredientsModalAdd.getDefaultState())

					// refresh the list
					IngredientsActions.reload()
				}
			)
	}

	render() {
		const objSubmitButton = {}

		if (this.state.btnSubmitDisabled === true) {
			objSubmitButton.title = 'Enter ingredient to enable this button'
		}

		return (
			<Card body inverse color="secondary">
				<CardTitle>
					Add New Ingredient
				</CardTitle>
				<CardBody style={{ margin: 0, padding: 0 }}>
					<Container fluid style={{ margin: 0, padding: 0 }}>
						<Row>
							<Col xs={3}>
								Ingredient
							</Col>
							<Col xs={9}>
								<Input
									name="ingredient"
									value={this.state.ingredient}
									onChange={this.handleChange}
									maxLength={32}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								&nbsp;
							</Col>
						</Row>
						<Row>
							<Col
								xs={12}
								className="text-right"
							>
								<Button
									onClick={this.submit}
									color="success"
									disabled={this.state.btnSubmitDisabled}
									{...objSubmitButton}
								>
									Add New Ingredient
								</Button>
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredients/add.jsx